/* 検索項目 日付~日付 */
import React, { memo } from 'react';
import DatePicker from './DatePicker';
import SearchLabel from '../atoms/SearchLabel';
import moment from 'moment-timezone';
var SearchDate = function (_a) {
    var id = _a.id, label = _a.label, value = _a.value, onChange = _a.onChange;
    return (React.createElement("div", { className: "col-md-4" },
        React.createElement(SearchLabel, { label: label }),
        React.createElement(DatePicker, { id: id, handleChangeDate: function (date) { return onChange(id, date); }, selected: value.length > 0 ? new Date(moment.tz(value, moment.tz.guess()).format()) : null, customInput: React.createElement("input", { type: "text", className: "search-from" }) })));
};
export default memo(SearchDate);
